import { BulletList } from '@tiptap/extension-list';
import { selectionInHeadingOrSubheadingParagraph } from '../lib/post_editor_paragraph_style.js';
import {
  listAttrsForIndent,
  normalizeIndentedListItemsInRange,
} from '../lib/post_list_indent.js';

export const PathstoneBulletList = BulletList.extend({
  addCommands() {
    return {
      toggleBulletList:
        () =>
        ({ chain, state }) => {
          if (selectionInHeadingOrSubheadingParagraph(state)) return false;

          const listAttrs = listAttrsForIndent(state);
          const normalizeLists = () =>
            ({ tr }) => {
              const { from, to } = tr.selection;
              normalizeIndentedListItemsInRange(tr, from, to);
              return true;
            };

          if (this.options.keepAttributes) {
            return chain()
              .toggleList(this.name, this.options.itemTypeName, this.options.keepMarks, listAttrs)
              .updateAttributes(this.options.itemTypeName, this.editor.getAttributes('textStyle'))
              .command(normalizeLists)
              .run();
          }

          return chain()
            .toggleList(this.name, this.options.itemTypeName, this.options.keepMarks, listAttrs)
            .command(normalizeLists)
            .run();
        },
    };
  },
});
